<nav>
    <div class="d-flex align-items-center justify-content-center p-2 nav-header w-100 flex-shrink-0">
        @if (!isNavBarCollapsed) {
            <div class="logo d-flex p-2 me-2 justify-content-center align-items-center">
                <img [src]="logo" alt="Feedonomics" height="28">
            </div>
            <span class="h5 mb-0">Feedonomics</span>
        }
        <button
            type="button"
            [ngClass]="{ 'ms-auto': !isNavBarCollapsed, 'p-0': isNavBarCollapsed }"
            class="btn btn-ghost"
            (click)="onToggleNavVisibility()">
            <fa-icon [icon]="faArrowLeftToLine" class="no-margin" [transform]="isNavBarCollapsed ? 'rotate-180' : 'rotate-0'"/>
        </button>
    </div>

    @if (isNavBarCollapsed) {
        <fdx-app-vertical-menu-collapsed class="h-100"/>
    } @else {
        <fdx-app-vertical-menu-expanded class="h-100"/>
    }

    @if (!isNavBarCollapsed) {
        @if (isClientDemoView && !isImpersonatingUser) {
            <div class="d-flex justify-content-center py-1 text-light fw-medium fs-smaller demo-view">
                Demo view
            </div>
        }
        <div
            class="d-flex justify-content-center py-1 text-secondary fw-medium fs-smaller gap-1"
            [ngClass]="currentSurfaceTierBg">
            <fdx-surface-tier-icon-button
                [clickable]="false"
                [tier]="currentSurfaceTier.tier"
                size="sm"/>
            <span>{{ currentSurfaceTier.displayName }}</span>
        </div>

        <!-- Expanded footer with dropdown menu open on click -->
        <div ngbDropdown
             id="menuOptions"
             (openChange)="onFooterMenuOpenChange($event)"
             placement="top-start">
            <div
                ngbDropdownToggle
                class="d-flex align-items-center flex-shrink-0 align-self-stretch w-100 footer gap-2 p-2 cursor-pointer"
                [ngbTooltip]="footerPopover"
                [disableTooltip]="isFooterMenuOpen"
                [openDelay]="600"
                #footerTooltip="ngbTooltip"
                tooltipClass="tooltip-wide show"
                placement="end-bottom">
                <fdx-user-avatar
                    [userLoaded]="user?.user_fetched"
                    [id]="user?.user_id"
                    [firstName]="user?.first_name"
                    [lastName]="user?.last_name"/>
                <div class="vstack user-details justify-content-center">
                    <span class="h6 mb-0 text-truncate">
                        {{accountName}}
                    </span>
                    @if (databaseName) {
                        <p class="mb-0 text-secondary text-truncate">
                            {{databaseName}}
                        </p>
                    }
                </div>
            </div>

            <div
                ngbDropdownMenu
                class="rounded-3 ms-2"
                aria-labelledby="profileInfo">
                <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
            </div>
        </div>
    } @else {
        @if (isClientDemoView && !isImpersonatingUser) {
            <div class="d-flex justify-content-center py-1 text-light fw-medium fs-smaller demo-view">
                Demo
            </div>
        }
        <div
            class="d-flex justify-content-center py-1 text-secondary fw-medium fs-smaller gap-1"
            [ngClass]="currentSurfaceTierBg">
            <fdx-surface-tier-icon-button
                [clickable]="false"
                [tier]="currentSurfaceTier.tier"
                size="sm"
                [ngbTooltip]="currentSurfaceTier.displayName"/>
        </div>

        <!-- Collapsed footer with dropdown menu open on hover -->
        <div ngbDropdown
             fscHoverDropdown
             [openDelay]="400"
             [closeDelay]="400"
             (openChange)="onFooterMenuOpenChange($event)"
             placement="right-bottom">
            <div
                ngbDropdownToggle
                class="d-flex align-items-center flex-shrink-0 align-self-stretch w-100 footer gap-2 p-2 cursor-pointer justify-content-center">
                <fdx-user-avatar
                    [userLoaded]="user?.user_fetched"
                    [id]="user?.user_id"
                    [firstName]="user?.first_name"
                    [lastName]="user?.last_name"/>
            </div>

            <div
                ngbDropdownMenu
                class="rounded-3"
                aria-labelledby="profileInfo">
                <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
            </div>
        </div>
    }

    <ng-template #footerPopover>
        <div class="vstack text-start">
            <span>{{accountName}}</span>
            <span>{{databaseName}}</span>
        </div>
    </ng-template>

    <ng-template #dropdownMenu>
        <div class="d-flex gap-2 px-3 py-2 align-items-center">
            <fdx-user-avatar
                [userLoaded]="user?.user_fetched"
                [id]="user?.user_id"
                [firstName]="user?.first_name"
                [lastName]="user?.last_name"/>
            <p class="mb-0 text-dark text-truncate fw-medium" [ngbTooltip]="userName" placement="end">{{userName}}</p>
        </div>
        <div class="dropdown-divider"></div>

        @if (databaseName && accountName) {
            <button
                type="button"
                class="dropdown-item"
                (mouseenter)="dbAndAccountNameHovered = true"
                (mouseleave)="dbAndAccountNameHovered = false"
                (focus)="dbAndAccountNameHovered = true"
                (blur)="dbAndAccountNameHovered = false"
                (click)="copyDbAndAccountNames()">
                <div class="fdx-gray-caps pb-2">
                    <span>Account Details</span>
                    @if (!hasCopiedNames) {
                        <fa-icon
                            [icon]="copyIcon"
                            class="ms-1 copy-names"
                            [ngClass]="{ 'invisible': !dbAndAccountNameHovered }">
                        </fa-icon>
                    } @else {
                        <fa-icon
                            [icon]="checkIcon"
                            class="ms-1 text-success">
                        </fa-icon>
                    }
                </div>
                <div class="d-inline-block w-100 text-wrap text-truncate">
                    <span>{{ accountName }}</span>
                    <fa-icon
                        [icon]="chevronRightIcon"
                        size="xs"
                        class="mx-1 text-secondary">
                    </fa-icon>
                    <span>{{ databaseName }}</span>
                </div>

            </button>

            <div class="dropdown-divider mx-2"></div>
        }
        @let storeUrl = bigCommerceStoreLinkService.appUrl$ | async;
        @if (storeUrl) {
            <a
                ngbDropdownItem
                [attr.href]="storeUrl"
                target="_blank"
                rel="noopener"
                referrerpolicy="no-referrer">
                <fa-icon
                    [icon]="faArrowUpRightFromSquare"
                    class="me-2 text-secondary"/>
                <span>Back to BigCommerce</span>
            </a>
        }
        <a ngbDropdownItem
           [routerLink]="linkService.logsChangeLink">
            <fa-icon
                [icon]="faClockRotateLeft"
                class="me-2 text-secondary"/>
            <span>Change logs</span>
        </a>

        @if ((isPrivacyLevelAtLeastAnalyst || isClientDemoView) && !isImpersonatingUser) {
            <div class="dropdown-divider mx-2"></div>
            <div class="dropdown-header fdx-gray-caps">Internal Only</div>
            <a
                ngbDropdownItem
                [routerLink]="linkService.logsNewLink">
                <fa-icon [icon]="faClockRotateLeft" class="me-2 text-secondary"/>
                <span>Import/export logs</span>
            </a>
            <button
                ngbDropdownItem
                type="button"
                (click)="toggleClientDemoView()">
                <fa-icon
                    [icon]="isClientDemoView ? faArrowTurnLeft : faEye"/>
                <span>{{ isClientDemoView ? 'Return to default view' : 'Toggle client demo view' }}</span>
            </button>
            @if (isClientDemoView) {
                <a
                    ngbDropdownItem
                    [routerLink]="linkService.accountsLink">
                    <fa-icon [icon]="faArrowRightArrowLeft" class="me-2 text-secondary"/>
                    <span>Switch account</span>
                </a>
            }
        }

        <div class="dropdown-divider mx-2"></div>
        <a
            ngbDropdownItem
            class="text-danger"
            [routerLink]="linkService.logoutLink" [queryParams]="{'app': 'feedonomics', 'redirect': 'https://login.bigcommerce.com/login'}">
            <fa-icon
                class="me-2 text-danger"
                [icon]="faArrowRightFromBracket"/>
            <span>Log out</span>
        </a>
    </ng-template>
</nav>
